// extracted by extract-css-chunks-webpack-plugin
module.exports = {"groupLogo":"styles_groupLogo__2XBKK","forSideBar":"styles_forSideBar__2EYTJ"};